// extracted by mini-css-extract-plugin
export default {"communication-banner":"communication-banner--azJyh","communicationBanner":"communication-banner--azJyh"};